import { TFunction } from 'i18next';

// A coarse "N sec" / "N min" / "N h" remaining-time label for backend ETAs that
// are explicitly approximate (AI re-index estimates, background-job progress).
// Deliberately carries NO approximation marker: callers wrap it in their own
// copy ("~5 min", "≈ {duration} left"), and baking one in here doubles up.
// Returns '' for a missing, non-finite or already-elapsed duration so callers
// can render nothing without a null check of their own.
//
// Only the largest unit is shown — these are estimates, and re-indexing a large
// library runs for hours, where "150 min" reads as false precision.
const formatApproxDuration = (
  seconds: number | null | undefined,
  t: TFunction,
): string => {
  if (seconds == null || !Number.isFinite(seconds) || seconds < 0.5) return '';

  if (seconds < 60) {
    return `${Math.round(seconds)} ${t('sec-label')}`;
  }
  if (seconds < 3600) {
    return `${Math.floor(seconds / 60)} ${t('min-label')}`;
  }
  return `${Math.floor(seconds / 3600)} ${t('hour-label')}`;
};

export default formatApproxDuration;
